import {setSelectedCycle} from "../../handler/ParentDataHandler";

export const ReceiverFilterReducer = (state, action) => {
    switch (action.type) {
        case 'INITIALIZE_CYCLES':
            let allCycles = JSON.parse(action.cycleData.cycleList).filter(cycle => cycle.cycleId !== "AllCycles").map(cycle => {
                return {
                    ...cycle, displayableName : cycle.cycleId
                }
            }).sort((cycle1, cycle2) => (cycle1.cycleName > cycle2.cycleName) ? 1 : ((cycle2.cycleName > cycle1.cycleName) ? -1 : 0));
            let selectedCycles = JSON.parse(action.cycleData.selectedCycles).filter(cycle => cycle !== "AllCycles");
            return {
                ...state,
                selectedCycles: selectedCycles,
                allCycles: allCycles
            };
        case 'SELECT_CYCLE':
            setSelectedCycle([action.cycle]);
            return {
                ...state, selectedCycles: [action.cycle]
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/receive/reducers/ReceiveFilterReducer.js